export const ENTITY_TYPE_IDS = {
  ccorp: process.env.PUBLIC_ENTITY_TYPE_CCORP!,
  llc: process.env.PUBLIC_ENTITY_TYPE_LLC!,
  nonprofit: process.env.PUBLIC_ENTITY_TYPE_NONPROFIT!,
  soleprop: process.env.PUBLIC_ENTITY_TYPE_SOLEPROP!,
};

export const TAXED_AS = {
  SINGLE_MEMBER: "single_member",
  C_CORP: "taxed_as_c_corp",
  PARTNERSHIP: "partnership",
  S_CORP: "taxed_as_s_corp",
} as const;

export type TaxedAs = (typeof TAXED_AS)[keyof typeof TAXED_AS];

export const S_CORP_LABEL_SUFFIX = "(taxed as S-Corp)";

export const S_CORP_ENTITY_TYPE_NAMES = {
  corporation: "Corporation",
  llc: "LLC",
} as const;
